import styled, {css} from "styled-components";

const MyDeliveriesStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    position: relative;

    
.historySection {
   display: flex;
   gap: 8px;
   align-items: center;
   justify-content: start;
   color: #008755;
   cursor: pointer;
   font-size: 1.6rem;
   font-weight: 700;
   font-family: ${props => props.theme.fontBold};
}



.mobileDeliveryManagerWrapper {
    position: absolute;
    top: 20px;
    right: -110%;
    opacity: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
    background: white;
    transition: all 0.3s ease-in-out;
}

${props => {
        return (
            props.deliveryManagerExist &&
            css`
               .mobileDeliveryManagerWrapper {
                  right: 0;
                  opacity: 1;
}
            `
        );
    }}

@media only screen and (min-width: ${props => props.theme.tablet}) {
    width: 80%;
  }
`;

const StatusWrapper = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    flex-direction: column-reverse;
    gap: 24px;

    .searchErrorInfo {
        color: red;
        font-size: 1.2rem;
        font-weight: 400;
    }

   .inputWrapper {
        width: 100%;
        height: 40px;
        position: relative;



        & > input {
            width: 100%;
            height: 40px !important;
            font-size: 1.2rem;
            padding: 6px 4px 6px 12px !important;
            font-weight: 400;
            max-height: 40px !important;
            min-height: 40px !important;
            font-family: ${props => props.theme.fontRegular};
        }

        & > button {
            position: absolute;
            width: 30px;
            height: 30px;
            border-radius: 5px;
            background: #A5A6A8;
            display: flex;
            justify-content: center;
            align-items: center;
            right: 4px;
            top: 5px;
        }

        .active {
            background: #006150;
        }

      
        
    }

    @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
            flex-direction: row;
            gap: 0px;

            .inputWrapper {
                width: 250px;
            }
        }

`; 

const SettingsWrapper = styled.div`
    .pageTitle {
    font-size: 2.6rem;
    font-weight: 700;
    margin-bottom: 20px;
    color: #1B1E1C;
}


.backButton {
   display: flex;
   gap: 8px;
   align-items: center;
   justify-content: start;
   color: #008755;
   cursor: pointer;
   font-size: 1.6rem;
   font-weight: 700;
   margin-bottom: 20px;
}

.arrow {
    rotate: 180deg;
 }

`


export { 
	MyDeliveriesStyled,
    StatusWrapper,
    SettingsWrapper
    
 };


